var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptimisation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#3F6DB4;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st0",
    d: "M240.4,221.9H43.1c-9.8,0-17.7-7.9-17.7-17.7V83.3c0-9.8,7.9-17.7,17.7-17.7 c2.3,0,4.2,1.9,4.2,4.2c0,2.3-1.9,4.2-4.2,4.2c-5.2,0-9.4,4.2-9.4,9.4v120.9c0,5.2,4.2,9.4,9.4,9.4h197.3c5.2,0,9.4-4.2,9.4-9.4 V83.3c0-5.2-4.2-9.4-9.4-9.4c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2c9.8,0,17.7,7.9,17.7,17.7v120.9 C258.1,213.9,250.1,221.9,240.4,221.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st0",
    d: "M253.9,201.2H29.5c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2h224.4c2.3,0,4.2,1.9,4.2,4.2 C258.1,199.3,256.2,201.2,253.9,201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    className: "st0",
    d: "M155.7,244.2h-28c-2.3,0-4.2-1.9-4.2-4.2v-22.4c0-2.3,1.9-4.2,4.2-4.2h28 c2.3,0,4.2,1.9,4.2,4.2v22.4C159.9,242.4,158,244.2,155.7,244.2z M131.9,235.9h19.7v-14h-19.7V235.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    className: "st0",
    d: "M178.6,275.8h-73.8c-2,0-3.6-1.4-4.1-3.3c-0.4-1.9,0.6-3.9,2.3-4.7c15.8-7.2,15-27.3,15-27.5 c-0.1-1.1,0.4-2.2,1.1-3.1c0.8-0.8,1.9-1.3,3-1.3h39c1.1,0,2.2,0.5,3,1.3c0.8,0.8,1.2,1.9,1.1,3.1c0,0.8-0.7,20.4,15,27.5 c1.8,0.8,2.8,2.7,2.3,4.7C182.3,274.4,180.6,275.8,178.6,275.8z M117.3,267.5h48.9c-6.8-7.8-8.6-17.6-9-23.2h-30.9 C125.8,249.8,124,259.7,117.3,267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st0",
    d: "M199,275.8H84.4c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2H199c2.3,0,4.2,1.9,4.2,4.2 C203.2,273.9,201.3,275.8,199,275.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st0",
    d: "M158.2,201.2h-32.9c-2.3,0-4.2-1.9-4.2-4.2v-64.8c-1,0.3-2.1,0.4-3.1,0.4h-0.7 c-6.3,0-11.4-5.1-11.4-11.4V85c0-10.2,8.3-18.5,18.5-18.5h34.7c10.2,0,18.5,8.3,18.5,18.5v36.1c0,6.3-5.1,11.4-11.4,11.4h-0.7 c-1.1,0-2.1-0.2-3.1-0.4V197C162.3,199.3,160.5,201.2,158.2,201.2z M129.4,192.9H154v-71.7c0-2.3,1.9-4.2,4.2-4.2 c2.3,0,4.2,1.9,4.2,4.2c0,1.7,1.4,3.1,3.1,3.1h0.7c1.7,0,3.1-1.4,3.1-3.1V85c0-5.6-4.6-10.2-10.2-10.2h-34.7 c-5.6,0-10.2,4.6-10.2,10.2v36.1c0,1.7,1.4,3.1,3.1,3.1h0.7c1.7,0,3.1-1.4,3.1-3.1c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2 V192.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st0",
    d: "M125.3,125.3c-2.3,0-4.2-1.9-4.2-4.2V96.6c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2v24.6 C129.4,123.5,127.6,125.3,125.3,125.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st0",
    d: "M158.2,125.3c-2.3,0-4.2-1.9-4.2-4.2V96.6c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2v24.6 C162.3,123.5,160.5,125.3,158.2,125.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st0",
    d: "M141.7,62.9c-10.6,0-19.3-9-19.3-20.1c0-11.1,8.6-20.1,19.3-20.1c10.6,0,19.3,9,19.3,20.1 C161,53.8,152.4,62.9,141.7,62.9z M141.7,30.9c-6.1,0-11,5.3-11,11.8c0,6.5,4.9,11.8,11,11.8c6.1,0,11-5.3,11-11.8 C152.7,36.2,147.8,30.9,141.7,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st0",
    d: "M141.7,201.2c-2.3,0-4.2-1.9-4.2-4.2v-55.8c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2V197 C145.9,199.3,144,201.2,141.7,201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st0",
    d: "M207.5,188.3c-14.9,0-26.9-12.1-26.9-26.9c0-4.8,1.3-9.6,3.8-13.8c1.2-2,3.7-2.6,5.7-1.4 c2,1.2,2.6,3.7,1.4,5.7c-1.7,2.9-2.6,6.2-2.6,9.5c0,10.3,8.4,18.6,18.6,18.6c10.3,0,18.6-8.4,18.6-18.6c0-2.3,1.9-4.2,4.2-4.2 c2.3,0,4.2,1.9,4.2,4.2C234.4,176.2,222.3,188.3,207.5,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st0",
    d: "M222.6,148.4c-1,0-2-0.3-2.8-1c-5.5-4.8-13.6-6-20.2-2.9c-2.1,1-4.5,0.1-5.5-2 c-1-2.1-0.1-4.5,2-5.5c9.5-4.4,21.3-2.7,29.2,4.3c1.7,1.5,1.9,4.1,0.4,5.9C224.9,147.9,223.7,148.4,222.6,148.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M215.8,118.7c-12.2,0-22-9.9-22-22c0-12.2,9.9-22,22-22c12.2,0,22,9.9,22,22 c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2c0-7.6-6.2-13.7-13.7-13.7c-7.6,0-13.7,6.2-13.7,13.7s6.2,13.7,13.7,13.7 c3.2,0,6.1-1,8.6-3c1.8-1.4,4.4-1.1,5.8,0.6c1.4,1.8,1.1,4.4-0.6,5.8C225.7,116.9,220.8,118.7,215.8,118.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M197.9,100.8h-6.8c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2h6.8c2.3,0,4.2,1.9,4.2,4.2 C202,98.9,200.2,100.8,197.9,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M210.5,142.9c-0.2,0-0.4,0-0.6,0c-2.3-0.3-3.9-2.4-3.6-4.7l3.3-24.3c0.3-2.3,2.4-3.9,4.7-3.6 c2.3,0.3,3.9,2.4,3.6,4.7l-3.3,24.3C214.4,141.4,212.6,142.9,210.5,142.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st0",
    d: "M184.7,165.5h-11.2c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2h11.2c2.3,0,4.2,1.9,4.2,4.2 C188.8,163.6,187,165.5,184.7,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M76,188.3c-14.9,0-26.9-12.1-26.9-26.9c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2 c0,10.3,8.4,18.6,18.6,18.6s18.6-8.4,18.6-18.6c0-3.4-0.9-6.6-2.6-9.5c-1.2-2-0.5-4.5,1.4-5.7c2-1.2,4.5-0.5,5.7,1.4 c2.5,4.2,3.8,8.9,3.8,13.8C102.9,176.2,90.8,188.3,76,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M60.9,148.4c-1.1,0-2.3-0.5-3.1-1.4c-1.5-1.7-1.4-4.3,0.4-5.9c7.9-7,19.7-8.7,29.2-4.3 c2.1,1,3,3.4,2,5.5c-1,2.1-3.4,3-5.5,2c-6.6-3.1-14.7-1.9-20.2,2.9C62.8,148.1,61.8,148.4,60.9,148.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M67.7,118.7c-5,0-9.9-1.7-13.8-4.8c-1.8-1.4-2.1-4-0.6-5.8c1.4-1.8,4-2.1,5.8-0.6 c2.5,2,5.4,3,8.6,3c7.6,0,13.7-6.2,13.7-13.7s-6.2-13.7-13.7-13.7s-13.7,6.2-13.7,13.7c0,2.3-1.9,4.2-4.2,4.2 c-2.3,0-4.2-1.9-4.2-4.2c0-12.2,9.9-22,22-22c12.2,0,22,9.9,22,22C89.7,108.8,79.8,118.7,67.7,118.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st0",
    d: "M92.4,100.8h-6.8c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2h6.8c2.3,0,4.2,1.9,4.2,4.2 C96.6,98.9,94.7,100.8,92.4,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M72.9,142.9c-2,0-3.8-1.5-4.1-3.6L65.5,115c-0.3-2.3,1.3-4.4,3.6-4.7c2.3-0.3,4.4,1.3,4.7,3.6 l3.3,24.3c0.3,2.3-1.3,4.4-3.6,4.7C73.3,142.9,73.1,142.9,72.9,142.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M110,165.5H98.8c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2H110c2.3,0,4.2,1.9,4.2,4.2 C114.2,163.6,112.3,165.5,110,165.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimisation);
export default __webpack_public_path__ + "static/media/Optimisation.1564832be87c6e7f09d3cb745f99c891.svg";
export { ForwardRef as ReactComponent };